import { types } from "../types/types";

const INITIAL_STATE = {
  customers: null,
  customerWallets: null,
};

const customerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.addCustomers:
      return {
        ...state,
        customers: action.payload,
      };
    case types.removeCustomers:
      return {
        ...state,
        customers: null,
      };
    case types.addCustomerWallets:
      return {
        ...state,
        customerWallets: action.payload,
      };
    default:
      return state;
  }
};

export default customerReducer;
